import OwnerLayout from "@/components/owner/OwnerLayout";
import MessagesView from "@/components/messaging/MessagesView";

export default function OwnerMessagesPage() {
  return (
    <OwnerLayout testid="owner-messages-page">
      <MessagesView role="owner" />
    </OwnerLayout>
  );
}
